import React from "react";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  className?: string;
}

export function Select({ className = "", ...props }: SelectProps) {
  return (
    <select
      className={`w-full pl-3 pr-10 py-2 bg-duvi-surface border border-duvi-border rounded-[6px] text-duvi-text-primary focus:outline-none focus:border-duvi-accent transition-colors appearance-none bg-no-repeat bg-right ${className}`}
      style={{
        fontSize: "var(--text-sm)",
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2394A3B8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`,
        backgroundPositionX: "calc(100% - 12px)",
        backgroundPositionY: "center",
      }}
      {...props}
    />
  );
}
